import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFail = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7641_193798)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.35156 11.7778C3.35156 7.35957 6.93328 3.77734 11.3516 3.77734C15.7698 3.77734 19.3516 7.35957 19.3516 11.7778C19.3516 16.1961 15.7698 19.7783 11.3516 19.7783C6.93328 19.7783 3.35156 16.1961 3.35156 11.7778Z",
			fill: "#FF2A3B"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11.3516 14.6406C11.9216 14.6406 12.3837 15.1058 12.3838 15.6758C12.3838 16.2459 11.9216 16.7119 11.3516 16.7119C10.7815 16.7119 10.3193 16.2459 10.3193 15.6758C10.3195 15.1058 10.7816 14.6406 11.3516 14.6406ZM11.3516 6.83984C11.9213 6.83984 12.3836 7.30145 12.3838 7.87109V12.0732C12.3838 12.6431 11.9214 13.1055 11.3516 13.1055C10.7817 13.1055 10.3203 12.6431 10.3203 12.0732V7.87109C10.3205 7.30145 10.7819 6.83984 11.3516 6.83984Z",
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgFail);
export default ForwardRef;
